import React from "react";
import Term3_1 from "./Term3_1/Term3_1";
import TermData3_1 from "./Term3_1/Data/TermData";
import Term3_1_1 from "./Term3_1_1/Term3_1_1";

export default function TermVersionControl(term) {
  switch(term.version) {
    case "3.1":
      return {
        screen: <Term3_1 
          sectionData={TermData3_1(term)}
          isAccountLandingOverride={term.isAccountLandingOverride}
          heroImages={term.heroImages} 
          customContent={term.content}
          isPermProductAvailable={term.isPermProductAvailable}
          action={term.action} 
          scrollToElement={(anchor, offSet) => term.scrollToElement(anchor, offSet)} />,
        name: "Term Life Insurance",
      }
    case "3.1.1":
      term.stackForm = true;
      return {
        screen: <Term3_1_1
          sectionData={TermData3_1(term)}
          isAccountLandingOverride={term.isAccountLandingOverride}
          heroImages={term.heroImages} 
          customContent={term.content}
          isPermProductAvailable={term.isPermProductAvailable}
          action={term.action} 
          scrollToElement={(anchor, offSet) => term.scrollToElement(anchor, offSet)} />,
        name: "Term Life Insurance",
      }
  };
}